// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.jso`.

export const environment = {
  //apiUrlS: 'http://localhost:3006/api/dev/',
  //apiUrl: 'http://localhost:3005/api/dev/',
  //apiUrl: 'http://localhost:3000/api/dev/',
  apiUrl: 'https://chuyq3kjr8.execute-api.us-east-1.amazonaws.com/prod/api/dev/',
  // apiUrl: 'https://o3z1e9cczb.execute-api.us-east-1.amazonaws.com/test/api/dev/',
  apiUrlS: 'https://gykafq4cmb.execute-api.us-east-1.amazonaws.com/posgrado//unah/api/sec/dev/v1/mail/',

  // apiUrlS: 'http://10.8.13.20/seguridad/api/dev/',
  // apiUrlS: 'http://localhost:3005/api/dev/',
  // apiUrlS: 'http://api-internal.unah.edu.hn/seguridad/api/dev/',
  // apiUrl: 'http://api-internal.unah.edu.hn/posgrado/api/dev/',

// dev

  idSistema: "5D536BEB-F7C3-49CC-A72F-5458F0FBD093",
  tokenLocal: "token-posgrado",
  production: false,

  user: "userSI",
  pass: "41239dce31f4a00327456da94551d82fc62173a02ad4af",
  idSistemaFile: "2C1B431B-23A7-4418-BF0D-20048F74F206",
  idOrigen: "unah-SI",
  apiUtils:'https://fn419m464e.execute-api.us-east-1.amazonaws.com/dev/repositorio/api/files/dev/v1',
};

